import { Image } from '@wix/design-system';
import React from 'react';
// TODO this solution with using published flag images should be revisited. WSR team should provide a better solution for this.
export const CountryFlag = _ref => {
  let {
    countryKey
  } = _ref;
  return /*#__PURE__*/React.createElement(Image, {
    borderRadius: "50%",
    height: "16px",
    width: "16px",
    src: `https://static.parastorage.com/unpkg/@wix/wix-locale-data@0.0.3632/dist/images/svg-country-flags/${countryKey}.svg`
  });
};
//# sourceMappingURL=CountryFlag.js.map